import { URLS, getConfig } from '@constants';

import { buildRequestSignature } from '@base/utils';

import { IExtendedRESTApiRequestParams, ICommonRESTApiMethodParams } from './types';

function extendRequestParams<S>(
	commonParams: ICommonRESTApiMethodParams,
	requestSpecificParams: S,
	privateKey: string,
): S & IExtendedRESTApiRequestParams {
	const extParams = {
		/* eslint-disable @typescript-eslint/naming-convention */
		...requestSpecificParams,
		app_id: commonParams.app_id,
		session_key: commonParams.session_key,
		uid: commonParams.uid,
		ext: 1,
		cb: '',
		/* eslint-enable @typescript-eslint/naming-convention */
	};

	return {
		...extParams,
		sig: buildRequestSignature(commonParams.uid, extParams, privateKey),
	};
}

export const getRESTAPIUrl = <S>(
	commonParams: ICommonRESTApiMethodParams,
	requestSpecificParams: S,
	privateKey: string,
): string =>
		`${location.protocol}//${getConfig().hosts.restApiUrl}${URLS.REST_API}?` + Object
			.entries(extendRequestParams(commonParams, requestSpecificParams, privateKey))
			.reduce((pairs, pair) => [...pairs, pair.join('=')], [])
			.join('&');
